import React from 'react'
import { Row, Button } from 'reactstrap'
import { useHistory } from 'react-router-dom';
import { ArrowLeftCircle } from 'react-feather'
import { useSelector, useDispatch } from 'react-redux'
import { setDetailsParams } from '../../../../redux/slice/const'
import Tooltip from "@mui/material/Tooltip";

function NavbarDetails() {
    const { detailsParams } = useSelector(state => state.globalConst)
    const history = useHistory();
    const dispatch = useDispatch();

    const onClick = () => {
        history.goBack()
        dispatch(setDetailsParams({}))
    }

    return (
        <>
            {Object.keys(detailsParams).length !== 0 &&
                <Row className='d-lg-flex justify-content-between'>
                    <div className='d-xl-none w-25'></div>
                    <div className="w-50 d-none d-xl-block">
                        <Tooltip title="Regresar a Lista" placement="top-start" arrow>
                            <span>
                                <Button.Ripple
                                    className="btn-icon"
                                    color="flat-primary"
                                    id="ticketList"
                                    name="ticketList"
                                    onClick={onClick}>
                                    <ArrowLeftCircle size={24} />
                                </Button.Ripple>
                            </span>
                        </Tooltip>
                    </div>
                    <div className="text-center w-auto">
                        <h6>{detailsParams?.view}</h6>
                        <h5>{detailsParams?.intId}</h5>
                    </div>
                </Row>
            }
        </>
    )
}

export default NavbarDetails